(() => {
  if (window.bdmScrollControlsReady) return;
  window.bdmScrollControlsReady = true;

  const initialized = new WeakSet();

  const setup = (ui) => {
    if (initialized.has(ui)) return;

    const section = ui.closest(".shopify-section, section") || ui.parentElement;
    const rail = section?.querySelector("[data-bdm-scroll]");
    const range = ui.querySelector(".bdm-scroll-range");
    const dots = ui.querySelector(".bdm-scroll-dots");
    if (!rail || !range || !dots) return;

    initialized.add(ui);
    let dotCount = 0;
    let frame = 0;

    const maximum = () => Math.max(0, rail.scrollWidth - rail.clientWidth);

    const renderDots = (count) => {
      if (dotCount === count) return;
      dotCount = count;
      dots.replaceChildren();

      for (let index = 0; index < count; index += 1) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "bdm-scroll-dot";
        dot.setAttribute("aria-label", `Ir a la posición ${index + 1} de ${count}`);
        dot.addEventListener("click", () => {
          const progress = count === 1 ? 0 : index / (count - 1);
          rail.scrollTo({
            left: maximum() * progress,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
          });
        });
        dots.append(dot);
      }
    };

    const update = () => {
      frame = 0;
      const max = maximum();
      const isScrollable = max > 4;
      ui.hidden = !isScrollable;
      if (!isScrollable) return;

      const progress = Math.min(1, Math.max(0, rail.scrollLeft / max));
      const pages = Math.min(3, Math.max(2, Math.ceil(rail.scrollWidth / rail.clientWidth)));
      renderDots(pages);
      range.value = String(Math.round(progress * 1000));
      range.style.setProperty("--bdm-scroll-thumb", `${Math.max(18, rail.clientWidth / rail.scrollWidth * 100)}%`);

      const active = Math.min(pages - 1, Math.round(progress * (pages - 1)));
      dots.querySelectorAll(".bdm-scroll-dot").forEach((dot, index) => {
        dot.setAttribute("aria-current", index === active ? "true" : "false");
      });
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    range.addEventListener("input", () => {
      rail.scrollLeft = maximum() * (Number(range.value) / 1000);
    });
    rail.addEventListener("scroll", schedule, { passive: true });

    const resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(rail);
    Array.from(rail.children).forEach((item) => resizeObserver.observe(item));

    update();
  };

  const initialize = (root = document) => {
    root.querySelectorAll("[data-bdm-scroll-controls]").forEach(setup);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
